import Vue from 'vue'
import App from './App.vue'
// ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入router
import router from './router/router'
// 引入axios
import axios from 'axios'
import { myMixin } from './mixin/mixin';
import VueClipboard from 'vue-clipboard2'; // 确保路径正确
import directive from './directive' // directive
import '@/components/global/index.js' //全局组件库
import '@/assets/icons/index.js' //自动导入SVG文件
 import * as validata from '@/utils/validate'
// import vippopup from '@/components/vip_popup.vue'
// import login from '@/components/login.vue'
// Vue.use(vippopup)
// Vue.use(login)
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.use(directive)

// 挂载到Vue原型上
Vue.prototype.axios = axios;
Vue.config.productionTip = false
Vue.prototype.$validata = validata
//引入初始化样式
import store from '@/store' //状态管理
import '@/styles/index.scss'
// import './styles/scrollbar.scss';
// // 引入rem
// import './utils/rem'
// Vue.prototype.$EventBus = new Vue()
const domain = window.location.hostname;  // 返回如"www.example.com"
console.log('判断域名=', domain)
if(domain.includes('novel.esrke.com')){
  //  window.location = 'https://www.qmzuojia.com'
   window.location = 'https://qmzj.xueerd.com'
}
Vue.mixin(myMixin);
new Vue({
  el: '#app',
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')